import { render, staticRenderFns } from "./ReservationAppFormItem.vue?vue&type=template&id=22c29b63&scoped=true"
import script from "./ReservationAppFormItem.vue?vue&type=script&lang=js"
export * from "./ReservationAppFormItem.vue?vue&type=script&lang=js"
import style0 from "./ReservationAppFormItem.vue?vue&type=style&index=0&id=22c29b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c29b63",
  null
  
)

export default component.exports